import { z } from "zod";
//#region src/api/orpc/shared/urlSlug.ts
/**
* Shared URL slug constraints. Lowercase ASCII letters, digits and hyphen
* only — rejects zero-width / invisible characters that would otherwise
* silently 404 the exact-match DB lookup. Length cap aligns with the DNS
* label limit (RFC 1035) and the existing oauth applications convention.
*/
const URL_SLUG_PATTERN = /^[a-z0-9-]+$/;
const URL_SLUG_CHARSET_MESSAGE = "slug must contain only lowercase letters, numbers and \"-\"";
const URL_SLUG_MAX_LENGTH = 64;
/**
* Single-source-of-truth slug schema. Callers that need extra constraints
* (e.g. reserved-word refines) chain `.refine()` on top.
*/
const urlSlugSchema = z.string().min(1).max(64).regex(URL_SLUG_PATTERN, { message: URL_SLUG_CHARSET_MESSAGE });
//#endregion
export { URL_SLUG_CHARSET_MESSAGE, URL_SLUG_MAX_LENGTH, URL_SLUG_PATTERN, urlSlugSchema };
